<template>
  <div>
    <div>
      <div class="material-operation">
        <el-select
          v-model="operationValue"
          placeholder="请选择"
          size="small "
          @change="handleOperation"
          :disabled="selectedOption.length == 0"
        >
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-button class="btn" size="small " @click="sendMaterial"><i class="el-icon-plus el-icon--right add-icon"> 上传素材</i></el-button>
      </div>
      <div>
        <el-table
          ref="table"
          :data="materialList"
          class="material-table"
          v-loading="loading"
          :height="tableHeight"
          border
          @header-dragend="dragendHeader"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50" align="center"> </el-table-column>
          <el-table-column v-for="item in column" :key="item.prop" :prop="item.prop" :label="item.label" :width="item.width">
            <template slot-scope="scope">
              <div v-if="scope.column.property == 'path'" class="material-path">
                <div
                  v-if="scope.row.format.split('/')[0] == 'video'"
                  style="background: #e8e8e8; border-radius: 2px; height: 61px; width: 98px"
                >
                  <video :src="scope.row.path" controlslist="nodownload" width="98" height="61" style="border-radius: 2px" controls></video>
                </div>
                <div
                  v-else-if="scope.row.format.split('/')[0] == 'image'"
                  style="position: relative; height: 61px; width: 98px; background: #e8e8e8; border-radius: 2px"
                >
                  <img :src="scope.row.path" class="imgpic" />
                </div>
                <div v-else>
                  <svg-icon iconClass="folder1" />
                </div>
                <div style="display: flex">
                  <span class="name" :title="scope.row.name">{{ scope.row.name }}</span>
                  <span>{{ scope.row.format == "folder" ? "" : "." }}</span>
                  <span>{{ scope.row.format == "folder" ? "" : scope.row.format.split("/")[1] }}</span>
                  <svg-icon
                    iconClass="edit1"
                    class="edit-name"
                    @click="handleName(scope.row.name, scope.row.folderId, scope.row.uuid)"
                  ></svg-icon>
                </div>
              </div>
              <div v-else-if="scope.column.property == 'tags'">
                <div v-if="scope.row.tags && scope.row.tags.length" class="material-tag">
                  <el-tag :key="tag.id" v-for="tag in scope.row.tags" class="tag-style">
                    {{ tag.name }}
                  </el-tag>
                  <svg-icon
                    iconClass="edit1"
                    class="edit-create"
                    @click="addTags(scope.row.tags, scope.row.folderId, [scope.row.uuid], [scope.row.name])"
                  ></svg-icon>
                </div>
                <div v-else>
                  <span
                    style="color: rgba(24, 144, 255, 1); cursor: pointer"
                    @click="addTags(null, scope.row.folderId, [scope.row.uuid], [scope.row.name])"
                    >分配标签</span
                  >
                </div>
              </div>
              <div v-else-if="scope.column.property == 'designerName'">
                <div v-if="scope.row.designerName" class="material-designer">
                  <span>{{ scope.row.designerName }} </span>
                  <!-- <svg-icon
                    iconClass="edit1"
                    className="designer"
                    @click="handleDesigner(scope.row.designer, scope.row.folderId, [scope.row.uuid], [scope.row.name])"
                  ></svg-icon> -->
                </div>
                <div
                  v-else
                  style="color: rgba(24, 144, 255, 1); cursor: pointer"
                  @click="handleDesigner(null, scope.row.folderId, [scope.row.uuid], [scope.row.name])"
                >
                  分配
                </div>
              </div>

              <div v-else-if="scope.column.property == 'demanderName'">
                <div v-if="scope.row.demanderName" class="material-designer">
                  <span>{{ scope.row.demanderName }} </span>
                  <!-- <svg-icon
                    iconClass="edit1"
                    className="designer"
                    @click="handleDemander(scope.row.demander, scope.row.folderId, [scope.row.uuid], [scope.row.name])"
                  ></svg-icon> -->
                </div>
                <div
                  v-else
                  style="color: rgba(24, 144, 255, 1); cursor: pointer"
                  @click="handleDemander(null, scope.row.folderId, [scope.row.uuid], [scope.row.name])"
                >
                  分配
                </div>
              </div>
              <div v-else-if="scope.column.property == 'creativeSource'">
                <div v-if="scope.row.creativeSource" class="material-designer">
                  <span>{{ scope.row.creativeSource }} </span>
                  <svg-icon
                    iconClass="edit1"
                    className="designer"
                    @click="handlecreativeSource(scope.row.creativeSource, scope.row.folderId, [scope.row.uuid])"
                  ></svg-icon>
                </div>
                <div
                  v-else
                  style="color: rgba(24, 144, 255, 1); cursor: pointer"
                  @click="handlecreativeSource(null, scope.row.folderId, [scope.row.uuid])"
                >
                  分配
                </div>
              </div>

              <div v-else-if="scope.column.property == 'action'" class="action">
                <span @click="handleDetail(scope.row)">详情</span>
                <span @click="handleDelete([scope.row.name], scope.row.folderId, [scope.row.uuid])">删除</span>
              </div>
              <div v-else>
                <span>{{ scope.row[scope.column.property] ? scope.row[scope.column.property] : "-" }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <material-modal ref="materialRef" @updateTable="updateTable"></material-modal>
    <tags-modal ref="tagRef" @updateTags="updateTags" @clearOptionValue="clearOptionValue"></tags-modal>
    <designer-modal ref="desRef" @updateTags="updateTags" @clearOptionValue="clearOptionValue"></designer-modal>
    <demander-modal ref="demanRef" @updateTags="updateTags" @clearOptionValue="clearOptionValue"></demander-modal>
    <source-modal ref="sourceRef" @updateTags="updateTags" @clearOptionValue="clearOptionValue"></source-modal>
    <name-modal ref="nameRef" @updateTags="updateTags" @clearOptionValue="clearOptionValue"></name-modal>
    <detail-modal ref="detailRef"></detail-modal>
    <delete-modal ref="deleteRef" @updateTags="updateTags" @clearOptionValue="clearOptionValue"></delete-modal>
    <move-modal ref="moveRef" @updateTags="updateTags" @clearOptionValue="clearOptionValue"></move-modal>
  </div>
</template>

<script>
import MaterialModal from "./materialModal.vue";
import { column } from "./data";
import SvgIcon from "../../components/SvgIcon.vue";
import TagsModal from "./tagsModal.vue";
import DesignerModal from "./designerModal.vue";
import NameModal from "./nameModal.vue";
import DetailModal from "./detailModal.vue";
import DeleteModal from "./deleteModal.vue";
// import { delFilesFetch } from "../../api/material";
import MoveModal from "./moveModal.vue";
import DemanderModal from "./demanderModal.vue";
import SourceModal from "./sourceModal.vue";
export default {
  components: {
    MaterialModal,
    SvgIcon,
    TagsModal,
    DesignerModal,
    NameModal,
    DetailModal,
    DeleteModal,
    MoveModal,
    DemanderModal,
    SourceModal,
  },
  // props: { num: { required: false, default: "" } },
  props: {
    materialList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    folderId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      options: [
        {
          value: "1",
          label: "删除",
        },
        {
          value: "2",
          label: "复制",
        },
        {
          value: "3",
          label: "移动",
        },
        {
          value: "4",
          label: "分配标签",
        },
        {
          value: "5",
          label: "分配设计",
        },
        {
          value: "6",
          label: "分配后期",
        },
        // {
        //   value: "7",
        //   label: "分配是否原创",
        // },
      ],
      operationValue: "",
      column: column,
      tableHeight: window.innerHeight - 372,
      selectedOption: [],
    };
  },
  methods: {
    sendMaterial() {
      this.$refs.materialRef.showModal(this.folderId);
    },
    addTags(tags, folderId, fileNames, nameList) {
      this.$refs.tagRef.showModal(tags, folderId, fileNames, nameList);
    },
    handleDesigner(designers, folderId, fileNames, nameList) {
      this.$refs.desRef.showModal(designers, folderId, fileNames, nameList);
    },
    handleDemander(designers, folderId, fileNames, nameList) {
      this.$refs.demanRef.showModal(designers, folderId, fileNames, nameList);
    },
    handlecreativeSource(designers, folderId, fileNames) {
      this.$refs.sourceRef.showModal(designers, folderId, fileNames);
    },

    handleName(name, folderId, fileNames) {
      this.$refs.nameRef.showModal(name, folderId, fileNames);
    },
    updateTags(folderId) {
      this.$emit("getFiles", {
        id: folderId,
      });
    },
    handleDetail(row) {
      this.$refs.detailRef.showModal(row);
    },
    handleDelete(names, folderId, uuids) {
      this.$refs.deleteRef.showModal(names, folderId, uuids);
    },
    updateTable() {
      this.$emit("updateTable", { id: this.folderId });
    },
    handleOperation(e) {
      if (!this.selectedOption.length) {
        this.$message.warning("请选择素材");
        return;
      }
      let arr = [],
        names = [];
      this.selectedOption.map((item) => {
        arr.push(item.uuid);
        names.push(item.name);
      });
      switch (e) {
        case "1":
          this.$refs.deleteRef.showModal(names, this.folderId, arr);
          break;
        case "2":
          this.$refs.moveRef.showModal("复制素材", this.folderId, arr);
          break;
        case "3":
          this.$refs.moveRef.showModal("移动素材", this.folderId, arr);
          break;
        case "4":
          this.$refs.tagRef.showModal(null, this.folderId, arr, names);
          break;
        case "5":
          this.$refs.desRef.showModal(null, this.folderId, arr, names);
          break;
        case "6":
          this.$refs.demanRef.showModal(null, this.folderId, arr, names);
          break;
        case "7":
          this.$refs.sourceRef.showModal(null, this.folderId, arr);
          break;
        default:
          return;
      }
    },
    handleSelectionChange(e) {
      this.selectedOption = e;
      if (this.selectedOption.length == 0) {
        this.operationValue = null;
      }
      this.$emit("sendSelectOption", e);
    },
    dragendHeader() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    clearOptionValue() {
      this.operationValue = null;
    },
  },
};
</script>

<style lang="less" scoped>
.material-operation {
  display: flex;
  justify-content: space-between;
  margin: 12px 0;
  .btn {
    border: 1px solid rgba(24, 144, 255, 1);
    color: rgba(24, 144, 255, 1);
    padding: 0 12px;
  }
  .add-icon {
    margin-left: 0;
  }
}
.imgpic {
  max-width: 100%;
  max-height: 61px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.material-path {
  display: flex;
  width: 100%;
  .name {
    display: inline-block;
    // width: calc(100% - 28px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-left: 9px;
  }
  .edit-name {
    margin-top: 4px;
    margin-left: 2px;
    min-width: 15px;
  }
}
.tag-style {
  height: 22px;
  line-height: 22px;
  background: rgba(233, 233, 233, 0.6);
  border: rgba(233, 233, 233, 0.6);
  margin-right: 8px;
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.85);
}
.material-tag {
  cursor: pointer;
  .edit-create {
    display: none;
  }
  &:hover .edit-create {
    display: inline-block;
  }
}
.material-designer {
  .designer {
    display: none;
  }
  &:hover .designer {
    display: inline-block;
    cursor: pointer;
  }
}
</style>
<style lang="less">
.material-table {
  width: calc(100vw - 440px);
  .action {
    color: rgba(24, 144, 255, 1);
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    margin-right: 8px;
  }
  .el-table__row td {
    vertical-align: top;
  }
}
</style>
